import { render, staticRenderFns } from "./ItemSubGroup.vue?vue&type=template&id=23f6eeb6"
import script from "./ItemSubGroup.vue?vue&type=script&lang=js"
export * from "./ItemSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports